export default "__VITE_ASSET__DTC2b8vd__"